// extracted by mini-css-extract-plugin
export default {"label":"Input_label__NXpCD","input":"Input_input__E5rzA"};